/**
 * Two stacked chevrons pointing up (the legacy planner's `icons/double-arrow-up`). The
 * expand direction is the same glyph rotated — see ExpandCollapseButton.
 */
export default function IconDoubleArrowUp({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M19.501,15c-0.276,0 -0.5,-0.224 -0.5,-0.5c0,-0.276 0.224,-0.5 0.5,-0.5h2.474l-9.974,-12.691l-9.971,12.689h2.471c0.276,0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5h-2.471c-0.223,0 -0.443,-0.076 -0.618,-0.214c-0.433,-0.34 -0.508,-0.97 -0.168,-1.403l9.971,-12.689c0.049,-0.062 0.105,-0.119 0.168,-0.168c0.175,-0.138 0.394,-0.214 0.617,-0.214c0.31,0 0.596,0.139 0.787,0.381l9.974,12.691c0.138,0.175 0.214,0.394 0.214,0.617c0,0.552 -0.448,1.001 -1,1.001h-2.474Z" />
      <path d="M2.03,22.998c-0.223,0 -0.443,-0.076 -0.618,-0.214c-0.433,-0.34 -0.508,-0.97 -0.168,-1.403l9.971,-12.689c0.049,-0.062 0.105,-0.119 0.168,-0.168c0.175,-0.138 0.394,-0.214 0.617,-0.214c0.31,0 0.596,0.139 0.787,0.382l9.971,12.691c0.138,0.175 0.214,0.395 0.214,0.618c0,0.552 -0.448,1 -1,1l-19.942,-0.003Zm0,-1l19.942,0.002l-9.971,-12.69l-9.971,12.688Z" />
    </svg>
  )
}
